export const MedicalToolsMenuIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.3335 17.5V11.6667M3.3335 8.33333V2.5M10.0002 17.5V10M10.0002 6.66667V2.5M16.6668 17.5V13.3333M16.6668 10V2.5M0.833496 11.6667H5.8335M7.50016 6.66667H12.5002M14.1668 13.3333H19.1668"
      stroke={props?.color || '#101828'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
